import { any, append, filter, includes, propEq } from 'ramda'
import React from 'react'

import CheckboxListItem from '../list/CheckboxListItem'
import List from '../list/List'

const CheckboxesList = ({
  options,
  useCleanValue,
  value,
  onSelect,
  onChange,
  cleanLabel,
  renderLabel,
  renderRightBorderColor,
  noWrapper
}) => {
  const values = value

  const handleSelect = (selected, value, label, origin) => {
    const selectedValue = useCleanValue ? value : { value, label, origin }
    const newValues = selected
      ? filter(v => (!useCleanValue ? selectedValue.value !== v.value : selectedValue !== v), values)
      : append(selectedValue, values)
    onChange(newValues)
    if (onSelect) onSelect(value, label, origin)
  }

  renderLabel = renderLabel || (item => item.label)
  return (
    <List noBorder={noWrapper}>
      {options.map((item, index) => {
        const selected = includes(item.value, values || []) || any(propEq('value', item.value), values || [])

        return (
          <CheckboxListItem
            key={item.label + item.value}
            label={renderLabel(item, selected)}
            sublabel={item.sublabel}
            selected={selected}
            cleanLabel={cleanLabel}
            onSelect={() => handleSelect(selected, item.value, item.label, item.origin)}
            rightBorderColor={renderRightBorderColor && renderRightBorderColor(item.value, item.label, item.origin)}
            noWrapper={noWrapper}
          />
        )
      })}
    </List>
  )
}

export default CheckboxesList
